import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { propOr } from 'ramda';
import { ApolloProvider } from 'react-apollo';
import { Provider, Loading, NavigationMenu } from '@shopify/app-bridge-react';
import { AppProvider } from '@shopify/polaris';
import { newClient } from '../apollo/client';
import CareerPortal from './CareerPortal';
import JobSetup from './JobSetup';
import JobSetupTemplate from './JobSetupTemplate';
import JobList from './JobList';
import JobCandidates from './JobCandidates';
import JobListTemplate from './JobListTemplate';
import Analytics from './Analytics';
import Integrations from './Integrations';
import GoogleSettings from './GoogleSettings';
import CandidateList from './CandidateList';
import Questionnaires from './Questionnaires';
import Questionnaire from './Questionnaire';
import Proxy from './Proxy';
import Jobs from './Jobs';
import JobSuccess from './JobSuccess';
import Settings from './Settings';
import SettingsIndex from './SettingsIndex';
import SucessScreen from './SucessScreen';
import Candidate from './Candidate';
import { ShophireProvider } from './ShophireProvider';
import EmailTemplateList from './EmailTemplateList';
import EmailTemplateSetup from './EmailTemplateSetup';

import CareerPortalIndex from '../views/CareerPortalIndex';
import HeroSection from '../views/HeroSection';
import IntroParagraphSection from '../views/IntroParagraphSection';
import EmployeeTestimonialsSection from '../views/EmployeeTestimonialsSection';
import DiversityStatementSection from '../views/DiversityStatementSection';
import DepartmentsSection from '../views/DepartmentsSection';
import BenefitsSection from '../views/BenefitsSection';
import JobListingsSection from '../views/JobListingsSection';
import JobDescriptionPage from '../views/JobDescriptionPage';
import PostApplyPage from '../views/PostApplyPage';
import TalentCommunitySection from '../views/TalentCommunitySection';
import Dashboard from '../views/Dashboard';
import CandidateSourcing from '../views/CandidateSourcingReport';
import JobViews from '../views/JobViewsReport';
import CareersViews from '../views/CareersViewsReport';
import AccountPlan from '../views/AccountPlan';
import { GoogleOAuthProvider } from '@react-oauth/google';

const Routes = () => {

  const node = document.getElementsByClassName('shop_container');
  const data = JSON.parse(node[0].getAttribute('data-react-props'));
  const shop = propOr({}, 'shop')(data);
  const profile = propOr({}, 'profile')(data);
  const { shopify_domain, shopify_token, primary_domain } = shop;
  const { career_page_link } = profile
  const primary_url = primary_domain ? primary_domain : shopify_domain;
  const dataConfig = document.getElementById('shopify-app-init').dataset;
  const hostParam = new URLSearchParams(window.location.search).get("host");
  const config = { forceRedirect: true, apiKey: dataConfig.apiKey, host: hostParam || dataConfig.host, };

  const jobPath = `${data.path}/jobs/:id`;
  const jobSuccessPath = `${jobPath}/success`;

  const clientId = '896846465632-8n9d05f7al9oparir0lharoreqsuk3hk.apps.googleusercontent.com';

   const careerPageUrl = career_page_link ? career_page_link : `https://${shopify_domain}/a/careers/`;

  return (
    <AppProvider>
      <Provider config={config}>
        <ApolloProvider client={newClient(app)}>
          <ShophireProvider>
            <NavigationMenu
              navigationLinks={[
                { label: "Dashboard", destination: `/dashboard?host=${config.host}` },
                { label: "Jobs", destination: `/job-list?host=${config.host}` },
                { label: "Candidates", destination: `/candidate-list?host=${config.host}` },
                { label: "Career Portal", destination: `/career-portal-index?host=${config.host}` },
                { label: "Analytics", destination: `/analytics?host=${config.host}` },
                { label: "Settings", destination: `/settings?host=${config.host}` },
              ]}
            />
            <Router>
              <Switch>
                <Route
                  exact
                  path='/integrations'
                  render={(routeProps) => (
                    <Integrations
                      {...routeProps}
                      app={window.app}
                      shopifyToken={shopify_token}
                      shopifyDomain={shopify_domain}
                      apiKey={dataConfig.apiKey}
                    />
                  )}
                />
                <Route
                  exact
                  path='/google-settings'
                  render={(routeProps) => (
                    <GoogleOAuthProvider clientId={clientId}>
                      <GoogleSettings {...routeProps} shopifyToken={shopify_token} primaryDomain={primary_url} clientId={clientId} />
                    </GoogleOAuthProvider>
                  )}
                />
                <Route
                  exact
                  path='/account-plan'
                  render={(routeProps) => (
                    <AccountPlan
                      {...routeProps}
                      shopifyToken={shopify_token}
                      shopifyDomain={shopify_domain}
                      apiKey={dataConfig.apiKey}
                      shopOrigin={shopify_domain}
                      app={window.app}
                    />
                  )}
                />
                <Route
                  exact
                  path={['/email-templates', '/settings/templates/email']}
                  render={(routeProps) => (
                    <EmailTemplateList {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} />
                  )}
                />
                <Route
                  exact
                  path={['/create-email-template', '/edit-email-template/:id']}
                  render={(routeProps) => <EmailTemplateSetup {...routeProps} shopifyToken={shopify_token} />}
                />
                <Route
                  exact
                  path='/'
                  render={(routeProps) => (
                    <Dashboard
                      {...routeProps}
                      app={window.app}
                      shopifyToken={shopify_token}
                      shopifyDomain={shopify_domain}
                      apiKey={dataConfig.apiKey}
                      shopOrigin={shopify_domain}
                      careerPageLink={careerPageUrl}
                    />
                  )}
                />
                <Route
                  exact
                  path='/career-portal-index'
                  render={(routeProps) => (
                    <CareerPortalIndex {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} careerPageLink={careerPageUrl} />
                  )}
                />
                <Route
                  exact
                  path='/career-portal'
                  render={(routeProps) => (
                    <CareerPortal {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} careerPageLink={careerPageUrl} />
                  )}
                />
                <Route
                  exact
                  path='/career-portal/hero-section'
                  render={(routeProps) => (
                    <HeroSection {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} careerPageLink={careerPageUrl} />
                  )}
                />
                <Route
                  exact
                  path='/career-portal/intro-paragraph-section'
                  render={(routeProps) => (
                    <IntroParagraphSection {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} />
                  )}
                />
                <Route
                  exact
                  path='/career-portal/employee-testimonials-section'
                  render={(routeProps) => (
                    <EmployeeTestimonialsSection {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} careerPageLink={careerPageUrl} />
                  )}
                />
                <Route
                  exact
                  path='/career-portal/diversity-statement-section'
                  render={(routeProps) => (
                    <DiversityStatementSection {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} careerPageLink={careerPageUrl} />
                  )}
                />
                <Route
                  exact
                  path='/career-portal/departments-section'
                  render={(routeProps) => (
                    <DepartmentsSection {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} careerPageLink={careerPageUrl} />
                  )}
                />
                <Route
                  exact
                  path='/career-portal/benefits-section'
                  render={(routeProps) => (
                    <BenefitsSection {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} careerPageLink={careerPageUrl} />
                  )}
                />
                <Route
                  exact
                  path='/career-portal/job-listings-section'
                  render={(routeProps) => (
                    <JobListingsSection {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} />
                  )}
                />
                <Route
                  exact
                  path='/career-portal/talent-community-section'
                  render={(routeProps) => (
                    <TalentCommunitySection {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} careerPageLink={careerPageUrl} />
                  )}
                />
                <Route
                  exact
                  path='/career-portal/job-description-page'
                  render={(routeProps) => (
                    <JobDescriptionPage {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} />
                  )}
                />
                <Route
                  exact
                  path='/career-portal/post-apply-page'
                  render={(routeProps) => (
                    <PostApplyPage {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} careerPageLink={careerPageUrl} />
                  )}
                />
                <Route
                  exact
                  path='/dashboard'
                  render={(routeProps) => (
                    <Dashboard
                      {...routeProps}
                      app={window.app}
                      shopifyToken={shopify_token}
                      apiKey={dataConfig.apiKey}
                      shopOrigin={shopify_domain}
                      shopifyDomain={shopify_domain}
                      careerPageLink={careerPageUrl}
                    />
                  )}
                />
                <Route
                  exact
                  path='/analytics'
                  render={(routeProps) => (
                    <Analytics {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} />
                  )}
                />
                <Route
                  exact
                  path='/analytics/job-description-views'
                  render={(routeProps) => (
                    <JobViews {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} />
                  )}
                />
                <Route
                  exact
                  path='/analytics/careers-page-views'
                  render={(routeProps) => (
                    <CareersViews {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} />
                  )}
                />
                <Route
                  exact
                  path='/analytics/candidate-sourcing'
                  render={(routeProps) => (
                    <CandidateSourcing {...routeProps} shopifyToken={shopify_token} shopifyDomain={shopify_domain} />
                  )}
                />

                <Route
                  exact
                  key='create-job-template'
                  path='/set-job-template'
                  render={(routeProps) => <JobSetupTemplate {...routeProps} shopifyToken={shopify_token} />}
                />
                <Route
                  exact
                  key='edit-job-template'
                  path='/set-job-template/:id'
                  render={(routeProps) => <JobSetupTemplate {...routeProps} shopifyToken={shopify_token} />}
                />
                <Route
                  exact
                  key='create-job'
                  path='/set-job'
                  render={(routeProps) => (
                    <JobSetup
                      {...routeProps}
                      prymaryUrl={primary_url}
                      shopifyDomain={shopify_domain}
                      shopifyToken={shopify_token}
                    />
                  )}
                />
                <Route
                  exact
                  key='edit-job'
                  path='/set-job/:id'
                  render={(routeProps) => (
                    <JobSetup
                      {...routeProps}
                      prymaryUrl={primary_url}
                      shopifyDomain={shopify_domain}
                      shopifyToken={shopify_token}
                    />
                  )}
                />
                <Route
                  exact
                  path='/job-list'
                  render={(routeProps) => <JobList {...routeProps} shopifyDomain={shopify_domain} shopifyToken={shopify_token} careerPageLink={careerPageUrl} />}
                />
                <Route
                  exact
                  path={['/job-list-template', '/settings/templates/job-descriptions']}
                  render={(routeProps) => <JobListTemplate {...routeProps} shopifyToken={shopify_token} />}
                />
                <Route
                  exact
                  path={['/job-candidates/:id', '/job-candidates/:id/:tab']}
                  render={(routeProps) => (
                    <JobCandidates
                      {...routeProps}
                      prymaryUrl={primary_url}
                      shopifyDomain={shopify_domain}
                      shopifyToken={shopify_token}
                    />
                  )}
                />
                <Route
                  exact
                  path={['/candidate-list', '/candidate-list/:tab']}
                  render={(routeProps) => <CandidateList {...routeProps} shopifyToken={shopify_token} />}
                />
                <Route
                  exact
                  path='/candidate/:id'
                  render={(routeProps) => <Candidate {...routeProps} shopifyToken={shopify_token} />}
                />
                <Route
                  exact
                  path={['/questionnaires', '/settings/templates/questionnaires']}
                  render={(routeProps) => <Questionnaires {...routeProps} shopifyToken={shopify_token} />}
                />
                <Route
                  exact
                  path={['/questionnaire', '/questionnaire/:id']}
                  render={(routeProps) => (
                    <Questionnaire {...routeProps} shopifyDomain={shopify_domain} shopifyToken={shopify_token} />
                  )}
                />
                <Route
                  exact
                  path='/settings'
                  render={(routeProps) => (
                    <SettingsIndex
                      {...routeProps}
                      apiKey={dataConfig.apiKey}
                      shopOrigin={shopify_domain}
                      shopifyToken={shopify_token}
                    />
                  )}
                />
                <Route
                  exact
                  path='/settings/:category'
                  render={(routeProps) => (
                    <Settings
                      {...routeProps}
                      app={window.app}
                      apiKey={dataConfig.apiKey}
                      shopOrigin={shopify_domain}
                      shopifyToken={shopify_token}
                    />
                  )}
                />
                <Route
                  exact
                  key='success-screen'
                  path='/success-screen/:id'
                  render={(routeProps) => <SucessScreen {...routeProps} shopifyToken={shopify_token} />}
                />

                <Route
                  exact
                  path={jobPath}
                  render={(routeProps) => (
                    <Jobs {...routeProps} path_url={data.path} jobPath={jobPath} shopifyToken={shopify_token} />
                  )}
                />
                <Route exact path={jobSuccessPath} render={(routeProps) => <JobSuccess {...routeProps} path_url={data.path} />} />
                <Route
                  exact
                  path={data.path}
                  render={(routeProps) => <Proxy {...routeProps} path_url={data.path} shopifyToken={shopify_token} />}
                />
              </Switch>
            </Router>
          </ShophireProvider>
        </ApolloProvider>
      </Provider>
    </AppProvider>
  );
};

export default Routes;
